module.exports = __webpack_public_path__ + "media/images/success-stories-3-5ecd96de35e0c320c01b72c77205cdd7.jpeg";